import React, { useMemo, useState } from "react";
import Layout from "../../../components/common/Layout";
import { ADMIN_NAV } from "../../../utils/navigation";

import SalaryStructureToolbar from "../../../components/finance/payroll/salary-structure/SalaryStructureToolbar";
import SalaryStructureTable from "../../../components/finance/payroll/salary-structure/SalaryStructureTable";
import SalaryStructureModal from "../../../components/finance/payroll/salary-structure/SalaryStructureModal";

import {
  salaryStructures as initialSalaryStructures,
  salaryComponents,
} from "../../../data/payrollMockData";

const departments = [
  "Engineering",
  "HR",
  "Finance",
  "Sales",
  "Operations",
];

export default function SalaryStructure() {
  const [structures, setStructures] = useState(initialSalaryStructures);

  const [search, setSearch] = useState("");
  const [departmentFilter, setDepartmentFilter] = useState("All");
  const [statusFilter, setStatusFilter] = useState("All");

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedStructure, setSelectedStructure] = useState(null);

  const filteredStructures = useMemo(() => {
    return structures.filter((item) => {
      const matchesSearch = item.structureName
        .toLowerCase()
        .includes(search.toLowerCase());

      const matchesDepartment =
        departmentFilter === "All" ||
        item.department === departmentFilter;

      const matchesStatus =
        statusFilter === "All" ||
        item.status === statusFilter;

      return (
        matchesSearch &&
        matchesDepartment &&
        matchesStatus
      );
    });
  }, [structures, search, departmentFilter, statusFilter]);

  const handleSave = (formData) => {
    if (selectedStructure) {
      setStructures((prev) =>
        prev.map((item) =>
          item.id === selectedStructure.id
            ? { ...selectedStructure, ...formData }
            : item
        )
      );
    } else {
      setStructures((prev) => [
        ...prev,
        {
          id: Date.now(),
          ...formData,
        },
      ]);
    }

    setSelectedStructure(null);
    setIsModalOpen(false);
  };

  const handleDelete = (id) => {
    const confirmDelete = window.confirm(
      "Delete this salary structure?"
    );

    if (!confirmDelete) return;

    setStructures((prev) =>
      prev.filter((item) => item.id !== id)
    );
  };

  return (
    <Layout navItems={ADMIN_NAV}>
      <div className="finance-page">

        <div className="finance-page-header">
          <div>
            <h1>Salary Structure</h1>
            <p>
              Manage salary templates for different
              departments and designations.
            </p>
          </div>
        </div>

        <SalaryStructureToolbar
          search={search}
          setSearch={setSearch}
          departmentFilter={departmentFilter}
          setDepartmentFilter={setDepartmentFilter}
          statusFilter={statusFilter}
          setStatusFilter={setStatusFilter}
          onAdd={() => {
            setSelectedStructure(null);
            setIsModalOpen(true);
          }}
          departments={departments}
        />

        <SalaryStructureTable
          structures={filteredStructures}
          onEdit={(structure) => {
            setSelectedStructure(structure);
            setIsModalOpen(true);
          }}
          onDelete={handleDelete}
        />

        <SalaryStructureModal
          isOpen={isModalOpen}
          onClose={() => {
            setSelectedStructure(null);
            setIsModalOpen(false);
          }}
          onSave={handleSave}
          initialData={selectedStructure}
          salaryComponents={salaryComponents}
          departments={departments}
        />

      </div>
    </Layout>
  );
}